"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
/* eslint-disable */
/* TODO: fix ALL linting errors as some may call out code smells */
const prop_types_1 = __importDefault(require("prop-types"));
const classnames_1 = __importDefault(require("classnames"));
const form_checkbox_module_scss_1 = __importDefault(require("./form-checkbox.module.scss"));
const FormCheckbox = ({ children, className, hideLabel, label, onChange = () => { }, containerAttributes = {}, ...other }) => {
    const classes = (0, classnames_1.default)({
        [`${className}__active`]: className && other.checked
    }, className, containerAttributes.className);
    // className is added to the classes string above
    // remove className field to prevent it from overwritting the className we specify
    delete containerAttributes.className;
    const labelTextClasses = (0, classnames_1.default)({
        'u-hiddenVisually': hideLabel || !label,
        [`${className}__label-text`]: className
    });
    const inputClassnames = (0, classnames_1.default)({ [`${className}__input`]: className }, 'u-hiddenVisually', form_checkbox_module_scss_1.default.formCheckbox__input);
    const labelClassnames = (0, classnames_1.default)({ [`${className}__label`]: className }, form_checkbox_module_scss_1.default.formCheckbox__label);
    return ((0, jsx_runtime_1.jsxs)("div", { className: classes, ...containerAttributes, children: [(0, jsx_runtime_1.jsx)("input", { className: inputClassnames, type: 'checkbox', onChange: onChange, ...other }), (0, jsx_runtime_1.jsxs)("label", { htmlFor: other.id, className: labelClassnames, children: [(0, jsx_runtime_1.jsx)("span", { className: labelTextClasses, children: label }), children] })] }));
};
FormCheckbox.propTypes = {
    /** Id to the FormCheckout component. */
    id: prop_types_1.default.string.isRequired,
    /** Content that will be rendered as children of the FormCheckbox component. */
    children: prop_types_1.default.node,
    /** Applies a custom class to the FormCheckbox component. This class will be used as block name using BEM naming conventions. */
    className: prop_types_1.default.string,
    /** Checked propery to the FormCheckout component. */
    checked: prop_types_1.default.bool,
    /** Disabled propery to the FormCheckout component. */
    disabled: prop_types_1.default.bool,
    /** Applies a label to the FormCheckout component. */
    label: prop_types_1.default.node,
    /** Hide Label of the FormCheckout component. */
    hideLabel: prop_types_1.default.bool,
    /** OnChange event to the FormCheckout component. */
    onChange: prop_types_1.default.func,
    /** attributes to be applied to the containing div */
    containerAttributes: prop_types_1.default.objectOf(prop_types_1.default.string)
};
exports.default = FormCheckbox;
//# sourceMappingURL=form-checkbox.js.map